import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/shopcart/upload_b2b.png'
import _imports_1 from '@/assets/image/shopcart/un_upload_b2b.png'


const _withScopeId = n => (_pushScopeId("data-v-45c80fb3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-file-modal-content" }
const _hoisted_2 = { class: "upload-part" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "upload-part-img"
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "upload-part-img"
}
const _hoisted_5 = { class: "upload-part-text" }
const _hoisted_6 = { class: "download-template" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "download-tip" }

import { t, lang } from '@/plugins/i18n'
import { ref, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import CommonDialog from '@/components/common/CommonDialog.vue'
import UploadFailTable from './UploadFailTable.vue'
import { ElMessage as message } from 'element-plus'
import { isD2C, isJA, isMultiStore, useSite } from '@/store'
import { getExcelFileData } from '@/util/useXlsx'
import { shippingImportSkuApi } from '@/apis/order'
import { excelOrderTemplateHref} from '@/common/const'

export default /*#__PURE__*/_defineComponent({
  props: ['visible', 'sendType', 'isChoice'],
  emits: ['update:visible', 'submit', 'error'],
  setup(__props, { emit: emits }) {

const props = __props
const store = useStore()

// sendType 0-其他条形码 1-fba 2-乐天 3-shoplist 4-zozotown
// isChoice 是否是一价全包商品


const loading = ref(false)

const file = ref()
const errorList = ref([])
const uploadFailTableVisible = ref(false)
const upload = (uploadFile: any) => {
  console.log(uploadFile)
  if (uploadFile.size > 20 * 1024 * 1024) {
    message.warning(t('文件大于20M,请重新上传'))
    return false
  }
  file.value = uploadFile
  return false
}
const ok = () => {
  if (!file.value) {
    message.warning(t('请上传文件'))
    return
  }
  uploadOrder()
}
const cancel = () => {
  file.value = null
  emits('update:visible', false)
  loading.value = false
}
const EXCEL_1 = t('平台SKU')
const EXCEL_2 = t('FNSKU')
const EXCEL_3 = t('发货数量2')
const EXCEL_4 = t('客户SKU')
const uploadOrder = () => {
  loading.value = true
  getExcelFileData(file.value).then(async (res: any) => {
    console.log(res, '文件')
    if (!res.length) {
      message.warning(t('请勿上传空文件'))
      loading.value = false
      return
    }
    const skuList: any = {}
    res.forEach((item: any, index: number) => {
      if (!skuList[item[EXCEL_1]]) {
        skuList[item[EXCEL_1]] = [{ ...item, index }]
        return
      }
      skuList[item[EXCEL_1]].push({ ...item, index })
    })
    console.log(skuList)
    const errors: any = []
    res.forEach((item: any, index: number) => {
      if (skuList[item[EXCEL_1]].length > 1 && item[EXCEL_1]) {
        errors.push({
          errorMessage: skuList[item[EXCEL_1]].map(v => `${t('X行').replace('X', v.index + 2)}`)?.join('と') + t('商品重复'),
          rowNumber: index + 2,
          productSku: item[EXCEL_1],
          fnSku: item[EXCEL_2],
          customerSku: item[EXCEL_4]
        })
      }
    })
    if (errors.length) {
      uploadFailTableVisible.value = true
      loading.value = false
      errorList.value = errors
      return
    }
    const params = {
      allIncludeFlag: props.isChoice ? 1 : 0,
      customerShopId: store.state.route.curShop,
      goodsCountry: 'CN',
      type: props.sendType,
      importData: res.map((item: any, index: number) => {
        if (props.sendType === 1) {
          return {
            fnSku: item[EXCEL_2],
            productSku: item[EXCEL_1],
            deliverNum: item[EXCEL_3],
            rowNumber: index + 2
          }
        }
        return {
          customerSku: item[EXCEL_4],
          productSku: item[EXCEL_1],
          deliverNum: item[EXCEL_3],
          rowNumber: index + 2
        }
      })
    }
    shippingImportSkuApi(params).then((res: any) => {
      const { data } = res
      if (data.errorList?.length) {
        uploadFailTableVisible.value = true
        errorList.value = data.errorList
      } else {
        emits('submit', data.skuList)
        cancel()
      }
      loading.value = false
    })
  }).catch(() => {
    loading.value = false
  })
}

const templateHref = () => {
  return (props.sendType === 1 ? excelOrderTemplateHref.ja.importShippingFba : excelOrderTemplateHref.ja.importShippingOther)
}

return (_ctx: any,_cache: any) => {
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CommonDialog, {
      visible: __props.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
      "show-close": false,
      width: 600,
      className: "upload-file-modal",
      onOk: ok,
      onCancel: cancel,
      title: _unref(t)('表格导入商品'),
      footer: true,
      loading: loading.value,
      disabled: !file.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_upload, {
            drag: "",
            action: "",
            "before-upload": upload,
            accept: ".xls,.xlsx"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (file.value)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                  : (_openBlock(), _createElementBlock("img", _hoisted_4)),
                _createElementVNode("div", _hoisted_5, _toDisplayString(!file.value ? _unref(t)('上传文件') : (file.value?.size / 1024 > 1024 ? (file.value?.size / 1024 /
    1024).toFixed(2) + 'M'
    : (file.value?.size / 1024).toFixed(0) + 'KB')), 1)
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("a", {
              href: templateHref() + '?v=' + new Date().getTime()
            }, _toDisplayString(_unref(t)('模板下载2')), 9, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, _toDisplayString(_unref(t)('注意事项')), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(t)('1.表格数据最多为1000行，超过请分多个表格导入')), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(t)('2.仅支持.xlsx、.xls文件，且小于20M')), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(t)('3.导入成功后，请在发货列表查看并核对发货数量')), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title", "loading", "disabled"]),
    _createVNode(UploadFailTable, {
      visible: uploadFailTableVisible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((uploadFailTableVisible).value = $event)),
      list: errorList.value,
      sendType: __props.sendType
    }, null, 8, ["visible", "list", "sendType"])
  ], 64))
}
}

})